const {
  getWindMetrics,
  calculateVectors,
  calculateAverageSpeed,
  calculateAverageDirection,
  filterValidFrames
} = require("./wind-calculations");

module.exports = {
  getWindMetrics,
  calculateVectors,
  calculateAverageSpeed,
  calculateAverageDirection,
  filterValidFrames
};
